import React, { useRef, useEffect, useState } from 'react'
import { ReactComponent as MySVG7 } from '../../../../../assets/brandokuma/symbol/MAN.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/brandokuma/symbol/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/brandokuma/symbol/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/brandokuma/symbol/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/brandokuma/symbol/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/brandokuma/symbol/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/brandokuma/symbol/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/brandokuma/symbol/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/brandokuma/symbol/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/brandokuma/symbol/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/brandokuma/symbol/KIDSBABYUNIT.svg'
import { ReactComponent as MySVG18 } from '../../../../../assets/brandokuma/symbol/LINGERIE.svg'



const renderShape = (currentShape, category, strokeColor = "#7c7d7f") => {
  const isFill =
    currentShape === 'WOMAN' ||
    currentShape === 'LINGERIE' ||
    currentShape === 'PREMIUM DENIM' ||
    currentShape === 'MAN' ||
    currentShape === 'TRF' ||
    currentShape === 'GIRL' ||
    currentShape === 'BOY';

  const commonStyle = isFill ? { fill: strokeColor } : { stroke: strokeColor };

  console.log(`Rendering: ${currentShape} | Category: ${category}`);
  console.log(`Using: ${isFill ? 'fill' : 'stroke'} with color ${strokeColor}`);

  if (category === 'Woman') {
    switch (currentShape) {
      case 'WOMAN':
        return (
          <MySVG11
            data-testid="svg-woman"
            style={{ width: `3.892mm`, height: "auto", ...commonStyle }}
          />
        );

      case 'LINGERIE':
        return (
          <MySVG18
            data-testid="svg-lingerie"
            style={{ width: `4.4mm`, height: "auto", ...commonStyle }}
          />
        );

      case 'PREMIUM DENIM':
        return (
          <MySVG11
            data-testid="svg-premium-denim"
            style={{ width: '3.852mm', height: "auto", ...commonStyle }}
          />
        );

      case 'BASIC':
        return (
          <MySVG10
            data-testid="svg-basic"
            style={{ width: '3.852mm', height: "auto", ...commonStyle }}
          />
        );

      case 'TRF':
        return (
          <MySVG12
            data-testid="svg-trf"
            style={{ width: '4.237mm', height: "auto", ...commonStyle }}
          />
        );

      default:
        return <></>;
    }
  } else if (category === 'Man') {
    switch (currentShape) {
      case 'DENIMWEAR':
        return (
          <MySVG9
            data-testid="svg-denimwear"
            style={{ width: '4.083mm',  height: "auto", ...commonStyle }}
          />
        );

      case 'MAN':
        return (
          <MySVG7
            data-testid="svg-man"
            style={{ width: '3.852mm',  height: "auto", ...commonStyle }}
          />
        );

      case 'GLOBAL':
        return (
          <MySVG8
            data-testid="svg-global"
            style={{ width: '3.852mm',  height: "auto", ...commonStyle }}
          />
        );

      default:
        return <></>;
    }
  } else if (category === 'Kids') {
    switch (currentShape) {
      case 'GIRL':
        return (
          <MySVG16
            data-testid="svg-girl"
            style={{ width: `3.852mm`, height: "auto", ...commonStyle }}
          />
        );

      case 'KIDS A (BABY GIRL)':
        return (
          <MySVG14
            data-testid="svg-kids-a"
            style={{ width: '3.852mm', height: 'auto', ...commonStyle }}
          />
        );

      case 'BABY UNIQUE':
      case 'KNIT':
      case 'DENIM':
      case 'OUTERWEAR':
        return (
          <MySVG17
            data-testid="svg-baby-unique"
            style={{ width: '4.622mm', height: 'auto', ...commonStyle }}
          />
        );

      case 'BOY':
        return (
          <MySVG15
            data-testid="svg-boy"
            style={{ width: '3.852mm', height: 'auto', ...commonStyle }}
          />
        );

      case 'KIDS O (BABY BOY)':
        return (
          <MySVG13
            data-testid="svg-kids-o"
            style={{ width: '3.852', height: 'auto', ...commonStyle }}
          />
        );

      default:
        return <></>;
    }
  } else {
    return <></>;
  }
};


// Referans adlarıyla bileşenleri tanımlıyoruz
const WLZCALL028 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"8.83px", top:"20.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"16.2px", width:"87.05%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center" }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.3px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.9px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"16.2px", width:"87.05%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"16.2px", width:"87.05%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "27.3px",
    width: "86.95%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#B1B4B3", fontSize:"8px", letterSpacing:0.48, marginTop:.1 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WLZCALL029 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"32.83px", top:"31.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.3px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.9px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
               className='HelveticaNeueLT57Condensed'

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "33.2%",
    width: "78.9%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 2,
  }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "37.1px",
    width: "78.87%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.5px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#B1B4B3", fontSize:"8px", letterSpacing:0.43 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};


const WLZCALL030 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"12.83px", top:"22.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "48.4%", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.48px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
               className='HelveticaNeueLT57Condensed'

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "48.4%",
    width: "78.9%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 2,
  }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "48.4%", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "27.15px",
    width: "84.7%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.7px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"8px", letterSpacing:0.43 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WLZCALL031 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"28.83px", top:"31.05px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"78.47%", display:"flex", justifyContent:"flex-end",zIndex:2 ,    transform: "translateY(-0.2px)" }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#767678",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.48px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
               className='HelveticaNeueLT57Condensed'

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "33.2%",
    width: "78.9%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 2,
  }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#767678",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"78.9%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#767678",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "37.1px",
    width: "78.87%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.5px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#767678", fontSize:"8px", letterSpacing:0.43 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WLZCALL035 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"48.5px", bottom:"92px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "35%", width:"93.3%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.7px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2.2px",
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.2px",

    fontWeight: 900,
    letterSpacing: "0.4px",
    fontSize: "8.2px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
style={{ border:"1px solid transparent", position:"absolute", left:0, top: "35%", width:"93.3%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "7.7px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "35%", width:"93.3%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.7px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    marginLeft:4.4,
    top: "102px",
    width:"93.3%",
    display: "flex",
    justifyContent: "center",
    zIndex:2,
    transform: "translateY(0.9px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#B1B4B3", fontSize:"7.7px", letterSpacing:0.4 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};


const WLZCALL036 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"48.5px", bottom:"92px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "34.9%", width:"92%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.7px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.35px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2.2px",
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5px",

    letterSpacing: "0.35px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.2px",

    fontWeight: 900,
    letterSpacing: "0.35px",
    fontSize: "8.2px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
style={{ border:"1px solid transparent", position:"absolute", left:0, top: "34.9%", width:"92%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#7d7d7f",
      fontSize: "7.7px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "34.9%", width:"92%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#7d7d7f",
    fontSize: "7.7px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    marginLeft:4.4,
    top: "101.8px",
    width:"92%",
    display: "flex",
    justifyContent: "center",
    zIndex:2,
    transform: "translateY(0.7px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#7d7d7f", fontSize:"7.7px", letterSpacing:0.36 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};

const WPZCALL001 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"58px", bottom:"132.1px" }}>
      {renderShape(currentShape, category, "#b1b4b3")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "36%", width:"94.4%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b1b4b3",
    fontSize: "7.7px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.3px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2.2px",
    fontSize: "8.2px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.2px",

    fontWeight: 900,
    letterSpacing: "0.5px",
    fontSize: "8.2px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
style={{ border:"1px solid transparent", position:"absolute", left:0, top: "36%", width:"94.4%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "7.7px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
        fontSize: "8.2px",        // Keep consistent base font size

      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "36%", width:"94.4%",marginLeft:4, display:"flex", justifyContent:"center",zIndex:2,    transform: "translateX(0.4px)" 
 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.7px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontSize: "8.2px",        // Keep consistent base font size

    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    marginLeft:4.4,
    top: "134px",
    width:"94.4%",
    display: "flex",
    justifyContent: "center",
    zIndex:2,
    transform: "translateY(0.9px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#b1b4b3", fontSize:"7.7px", letterSpacing:0.45 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};


const WPZCALL002 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}


      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"83.75%", display:"flex", justifyContent:"flex-end",zIndex:2,    transform: "translateY(0.2px)" 
}}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.3px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.5px", marginLeft:"0.2px"
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{

    fontWeight: 900,
    marginLeft:"2px",
    fontSize: "8px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
        marginLeft:"5.2px",

    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    marginLeft:"2.1px",

    fontWeight: 900,
    letterSpacing: "0.45px",
    fontSize: "8px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>


        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div
               className='HelveticaNeueLT57Condensed'

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "33.2%",
    width:"83.75%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 2,
  }}
>
  {/* Tek bir ebeveyn span */}
  <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#B1B4B3",
      fontSize: "7.3px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
</div>

      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top: "33.2%", width:"83.75%", display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#B1B4B3",
    fontSize: "7.3px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>

        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div

  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "29.5px",
    width:"83.77%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.6px)" 

  }}
>        <span  className='HelveticaNeueLT57Condensed' style={{ color:"#B1B4B3", fontSize:"7.3px", letterSpacing:0.53 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WPZCALL003 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"12.83px", top:"21.5px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "8px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ letterSpacing: "0.35px",
 }}>EUR</span>
  
  <span style={{ margin: "0 0.4px" ,   
}}>/</span>

  <span style={{ letterSpacing: "0.4px", 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.6px",
    fontSize: "8.5px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "5.6px",
    letterSpacing: "0.4px",

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    letterSpacing: "0.8px",
    marginLeft: "2.5px",
    fontSize: "8.5px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,top:"18.9px", width:"84.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#b2b5b4",
      fontSize: "8px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.8,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"18.9px", width:"84.7%",display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#b2b5b4",
    fontSize: "8px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      letterSpacing: 0.48,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "27.3px",
  
  width:"84.4%",
    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#b2b5b4", fontSize:"8px", letterSpacing:0.48, marginTop:.1 }}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};
const WPZCALL004 = ({currentShape, category, referance, CountryName, filteredIndo, inx, szrgrp, valueBasedOnInx,CardBackBack}) => {
  const [TopValue, setTopValue] = useState("27px")

  // Gelen değerleri konsolda görmek için:
  console.log("USA Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.usa);
  console.log("EUR Değeri:", szrgrp?.sizes?.[valueBasedOnInx]?.europe);
  const usaValue = szrgrp?.sizes?.[valueBasedOnInx]?.usa;
  const eurValue =szrgrp?.sizes?.[valueBasedOnInx]?.europe;
  const mexValue =szrgrp?.sizes?.[valueBasedOnInx]?.mexico;
  console.log("refrefgeldi",referance)

  useEffect(() => {
    if (
      referance?.linecount === inx || // linecount, inx'e eşitse
      referance?.linecount === 0 || // linecount 0 ise
      (referance?.linecount !== 0 && inx % referance?.linecount === 0) // linecount 0 değilse ve inx'in katıysa
    ) {
      setTopValue("27.1px");
    } else {
      setTopValue("27px");

    }
  }, [referance, inx]); // 👈 Bağımlılıklar (referance veya inx değiştiğinde çalışır)
  return (
    <div style={{ position:"relative", width:"100%", minHeight:`${referance.height+2.5}mm` }}>
       {CardBackBack ? (
    <div 
      style={{
        position: "absolute", 
        top: `0`, // Her öğe için 5% fark ekleyerek aşağı kaydırıyoruz
    left: "0",

      }}
    >
      {(() => {
        const referenceCode = referance?.code;
        const referenceWidth = referance?.width;
        let width = `${referenceWidth}mm`;
        let height = "auto";

        return typeof CardBackBack === "function" ? (
          <CardBackBack width={width} height={height} />
        ) : (
          <img src={CardBackBack} alt="SVG Image" style={{ width, height }} />
        );
      })()}
    </div>
  ) : (
    <span>Loading...</span>
  )}
      <div style={{ position:"absolute", right:"30.83px", top:"37px" }}>
        {renderShape(currentShape, category,"#7c7d7f")}
      </div>

      {/* Şart: USA ile EUR eşitse bu bloğu döndür */}
      
      {usaValue === eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"34.7px", width:"76.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center",    transform: "translateY(0.5px)" 
 }}>
        <span
  className='HelveticaNeueLT57Condensed'
  style={{
    color: "#bbbebd",
    fontSize: "7.5px",
    display: 'inline-flex',  // Changed to flex container
    alignItems: 'baseline',  // Proper baseline alignment
    lineHeight: '8.4px',  // big enough to accommodate the largest text
  }}
>
  <span style={{ 
 }}>EUR</span>
  
  <span style={{ margin: "0 0.3px" ,   
}}>/</span>

  <span style={{ 
 }}>USA</span>

  <span
    className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,
    marginLeft: "2.2px",
    fontSize: "8px",        // Keep consistent base font size

  }}>
    {usaValue}
  </span>

  <span style={{
    marginLeft: "4.3px",
 

  }}>
    MEX
  </span>

  <span 
  
  className='HelveticaNeueLT77BoldCondensed'

  style={{
    fontWeight: 900,

    marginLeft: "2.5px",
    fontSize: "8px",        // Keep consistent base font size


  }}>
    {mexValue}
  </span>
</span>

        </div>
      )}
      {usaValue !== eurValue && category !== "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0, top:"34.7px", width:"76.7%", display:"flex", justifyContent:"flex-end",zIndex:2,alignItems:"center"}}>
        <span
               className='HelveticaNeueLT57Condensed'
    style={{
      color: "#bbbebd",
      fontSize: "7.5px",
      // İsterseniz letterSpacing veya wordSpacing'i buradan da verebilirsiniz
      // letterSpacing: 0.48,
      // wordSpacing: "2px",
    }}
  >
    {/* EUR */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
        // marginTop: .1 --> inline-block'ta biraz yukarı boşluk yaratabilir
      }}
    >
      EUR
    </span>

    {/* EUR Value */}
    <span
      className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
      }}
    >
      {eurValue}
    </span>

    {/* USA */}
    <span
    
      style={{
        display: "inline-block",
        marginLeft: 2,
        letterSpacing: 0.48,
      }}
    >
      USA
    </span>

    {/* USA Value (Bold) */}
    <span

    className='HelveticaNeueLT77BoldCondensed'
      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
      }}
    >
      {usaValue}
    </span>

    {/* MEX */}
    <span
      style={{
        display: "inline-block",
        marginLeft: 2,
      }}
    >
      MEX
    </span>

    {/* MEX Value (Bold, different letterSpacing) */}
    <span
        className='HelveticaNeueLT77BoldCondensed'

      style={{
        display: "inline-block",
        marginLeft: 2,
        fontWeight: 600,
      }}
    >
      {mexValue}
    </span>
  </span>
        </div>
      )}
      {category === "Kids" && (
        <div style={{ border:"1px solid transparent", position:"absolute", left:0,  top:"34.7px", width:"76.7%",display:"flex", justifyContent:"flex-end",zIndex:2 }}>
        <span
               className='HelveticaNeueLT57Condensed'
  style={{
    color: "#bbbebd",
    fontSize: "7.5px",
    // Tek bir yerde letterSpacing ya da wordSpacing verebilirsiniz
    // letterSpacing: 0.48,
  }}
>
  {/* filteredIndo[inx]?.name */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.name}
  </span>

  {/* 'MONTH' / 'YEARS' */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    {szrgrp.name?.includes("BEBEK") ? "MONTH" : "YEARS"}
  </span>

  {/* filteredIndo[inx]?.cm?.slice(0, 3) */}
  <span
    className='HelveticaNeueLT77BoldCondensed'

    style={{
      display: "inline-block",
      marginLeft: 2,
      marginTop: 0.1, 
    }}
  >
    {filteredIndo[inx]?.cm?.slice(0, 3)}
  </span>

  {/* "CM" */}
  <span
    style={{
      display: "inline-block",
      marginLeft: 2,
      fontWeight: 600,
    }}
  >
    CM
  </span>
</span>
        </div>
      )}
      
      {/* MADE IN Kısmı */}
      <div
  style={{
    border: "1px solid transparent",
    position: "absolute",
    left: 0,
    top: "42.9px",
 width:"76.7%",

    display: "flex",
    justifyContent: "flex-end",
    zIndex:2,
    transform: "translateY(0.3px)"
  }}
>        <span   className='HelveticaNeueLT57Condensed' style={{ color:"#bbbebd", fontSize: "7.4px", marginTop:.1 ,letterSpacing:"0.15px"}}>
          MADE IN {CountryName}
        </span>
      </div>
    </div>
  );
};


const WPZCALL005 = () => (
  <div style={{ padding: 10, background: 'lightcoral', border: '1px solid red' }}>
    <h3>WPZCALL005 Bileşeni</h3>
  </div>
);

// Bileşenleri bir obje içinde saklıyoruz
const components = {
  WLZCALL028,
  WLZCALL029,
  WLZCALL030,
  WLZCALL031,
  WLZCALL035,
  WLZCALL036,
  WPZCALL001,
  WPZCALL002,
  WPZCALL003,
  WPZCALL004,
  WPZCALL005
  
};

// Gelen referansa göre bileşeni seçiyoruz
const Page1 = ({ selectColor,barcodeValue,data,harmacn,referance,SouthAmerica,sizeData,indo,szrgrp,inx,CardBackBack }) => {
  const [currentShape, setCurrentShape] = useState(null)
  console.log("dataaaaaaaaaaa",referance)
  const Component = components[referance?.code];

  const department = data.department
  const [brand, category, subCategory] = department.split(' / ')
  const filteredIndo = indo.filter((item) => item.amount !== '')

  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])
  const valueBasedOnInx = indexedIndo[inx]

  useEffect(() => {
    if (subCategory) {
      setCurrentShape(subCategory)
    }
  }, [subCategory])

  return (
    <Component 
      currentShape={currentShape}  
      category={category} 
      referance={referance} 
      CountryName={data?.country?.name} // ✅ Hata düzeltildi
      filteredIndo={filteredIndo}
      inx={inx}
      szrgrp={szrgrp}
      valueBasedOnInx={valueBasedOnInx}
      CardBackBack={CardBackBack}
    />
  );};

export default Page1;
